import { AbstractIcon } from './abstract';
import { componentsRegistryService } from 'cruzo';

export class PlayIcon extends AbstractIcon {
  static selector = "play-icon"

  getHTML() {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path d="M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28Z"/>
      </svg>`;
  }
}

componentsRegistryService.define(PlayIcon);